


































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

// Store types
import { SpacesGetter, ToolSpace, ToolSystemSuggestion } from '@/store/store.types';

/**
 *  Component that renders a space for which suggestions were computed.
 */
@Component
export default class SystemSpace extends Vue {

    /**
     *  The systemSpaceId for which the space is rendered.
     */
    @Prop({ type: String, required: true })
    private systemSpaceId!: string;

    /**
     *  The suggestion map for the space(s).
     */
    @Prop({ type: Object, required: true })
    private suggestion!: ToolSystemSuggestion;

    /**
     *  Used to get the fact if the system suggestions for this space
     *  are being shown by the `SystemsSuggestions.vue` component.
     */
    private get showing(): boolean {

        const showSystemSpaceId: string | null = this.$store.state.systems.suggestions.show;

        if (!showSystemSpaceId) {

            return false;

        }

        return showSystemSpaceId === this.systemSpaceId;

    }

    /**
     *
     *  Used to get the fact if a system is valid: everything has been selected.
     *
     *  (i) Delibaretely getting this out of the tool system
     *  state and not from the spaces state, because:
     *
     *  1) we don't want the space's single splits to be "selected" if
     *  a multi split has been selected for them and
     *  2) we also need to ensure his indoor units, including their colors, are selected
     *
     */
    public get valid(): boolean {

        let valid = false;

        for (const system of this.suggestion.systems) {

            if (!system.selected) {

                continue;

            }

            /**
             *  Check if the indoor unit and his color
             *  are selected for the space.
             */
            let validIndoorUnits = true;

            for (const indoorUnit of system.indoorUnits) {

                if (indoorUnit.toolSpaceId === null || indoorUnit.color === null) {

                    validIndoorUnits = false;

                }

            }

            valid = validIndoorUnits;

            /**
             *
             *  The space is valid if a system, including all his
             *  indoor units and their colors, are selected.
             *
             *  (i) We're only checking a single system, because only
             *  a single system can be selected for the space(s)
             *
             */
            if (valid) {

                break;

            }

        }

        return valid;

    }

    /**
     *
     *  Used to get the name of a space.
     *
     *  @param toolSpaceId The tool space id of the space to get the name for
     *
     *  @returns The name of the space
     *
     */
    private getSpaceName(toolSpaceId: string): string | null {

        const space: ToolSpace | null = this.$store.getters[SpacesGetter.ADDED][toolSpaceId];

        return space ? space.data.name : null;

    }

}
